<span (click)="openServerInfoDialog()">Version: {{versionInfo()}} ({{clientVersion.buildDate}})</span>
